"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointCreatedEvent = void 0;
class EndpointCreatedEvent {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointCreatedEvent.attributeTypeMap;
    }
}
exports.EndpointCreatedEvent = EndpointCreatedEvent;
EndpointCreatedEvent.discriminator = undefined;
EndpointCreatedEvent.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "EndpointCreatedEventData",
        "format": ""
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "EndpointCreatedEventTypeEnum",
        "format": ""
    }
];
//# sourceMappingURL=EndpointCreatedEvent.js.map